import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { Base } from '../base'

export const ReadonlyCustomInline = ({ fieldNamePrefix }) => {
  const locationFieldName = `${fieldNamePrefix}.location`
  const hideLocationFieldName = `${fieldNamePrefix}.hideLocation`

  const [{ value: locationFieldValue }] = useFormField({ name: locationFieldName })
  const [{ value: hideLocationFieldNameValue }] = useFormField({ name: hideLocationFieldName })

  return (
    <Base>
      <BodyText>{locationFieldValue}</BodyText>
      <BodyText color="muted" size="small">
        {hideLocationFieldNameValue
          ? I18n.t('publisher.event_type_editor.sections.event_details.location.fields.read_only.custom.hidden_label')
          : I18n.t('publisher.event_type_editor.sections.event_details.location.fields.read_only.custom.visible_label')}
      </BodyText>
    </Base>
  )
}
